import { inject as s, computed as n, withDirectives as b, createElementBlock as d, openBlock as u, unref as i, renderSlot as m, vShow as p } from "vue";
import { kebabCase as v } from "lodash-es";
const _ = ["id", "aria-labelledby", "area-selected"], h = /* @__PURE__ */ Object.assign({
  name: "DsTabItem"
}, {
  __name: "tab-item",
  props: {
    title: { type: String, required: !0 }
  },
  setup(r) {
    const e = r, l = s("registerTab", () => {
    }), c = s("activeTab", {}), t = v(e.title), a = n(() => c.value === e.title);
    return l({ title: e.title, slug: t }), (o, f) => b((u(), d("div", {
      id: `tab-content-${i(t)}`,
      role: "tabpanel",
      "aria-labelledby": `tab-${i(t)}`,
      "area-selected": a.value,
      class: "ds-tabs__content",
      "data-j-tab-item": ""
    }, [
      m(o.$slots, "default")
    ], 8, _)), [
      [p, a.value]
    ]);
  }
});
export {
  h as default
};
